import { Text } from "@gcs/design-system/react";
import styled from "styled-components/macro";
import ContentSlider from "components/CnpHolding/Slider/ContentSlider";
import * as S from "components/common/PresenceInfo/PresenceInfoFactory.style"  

export const Content = styled.section(({ theme }) => ({
  ...S.ContentFactory({theme}),
  padding: "50px 16px 0px 16px",
  backgroundColor: theme.color.brandPrimary.light,
  color: "white",
}));

export const Title = styled(Text)(({ theme }) => ({
  ...S.TitleFactory({ theme }),

  [theme.breakpoint.md()]: {
    paddingLeft: "18px"
  },

  [theme.breakpoint.lg()]: {
      paddingLeft: "64px"
  },

  
  marginBottom: "32px",
  color: "white",
}));

export const CardInfo = styled.div(({ theme, active }) => ({
  ...S.CardInfoFactory({theme, active}),
  marginBottom: "48px",
}));

export const CardIcon = styled.img(() => ({
  ...S.CardIconFactory(),
  width: "48px",
  height: "48px",
}));

export const CardContainer = styled.div(({ theme }) => ({
  ...S.CardContainerFactory(),
  borderLeftColor: "#FFF",
}));

export const CardTitle = styled(Text)(({ theme }) => ({
  ...S.CardTitleFactory({ theme }),
  color: "white",
}));

export const Description = styled(Text)(({ theme }) => ({
  ...S.DescriptionFactory({ theme }),
  color: "white",
}));

export const Paragraph = styled(Text)(({ theme }) => ({
  ...S.ParagraphFactory(),
  color: "#FFF"
}));

export const SlideCard = styled(ContentSlider)(({ theme }) => ({
  ...S.SliderCardFactory({theme})
}));

export const Container = S.ContainerFactory;
export const ContainerContent = S.ContainerContentFactory;
export const DesktopOnly = S.DesktopOnlyFactory;
export const MobileOnly = S.MobileOnlyFactory;
export const ContainerImage = S.ContainerImageFactory;